import { useContext } from 'react'
import WrappedStoryDispatchContext from './wrappedStoryDispatchContext'

function useWrappedStoryDispatch() {
  return useContext(WrappedStoryDispatchContext)
}

export default useWrappedStoryDispatch
